// @ts-nocheck
import * as Types from "../../../../types/types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type GetQueryAdvisorServerOverviewQueryVariables = Types.Exact<{
  serverId: Types.Scalars["ID"]["input"];
  checkGroupsAndNames?: Types.InputMaybe<
    Array<Types.Scalars["String"]["input"]> | Types.Scalars["String"]["input"]
  >;
}>;

export type GetQueryAdvisorServerOverviewQuery = {
  __typename?: "GraphqlQuery";
  getDatabases: Array<{
    __typename?: "Database";
    id: string;
    datname?: string | null;
    issueCount: number;
  }>;
};

export const GetQueryAdvisorServerOverviewDocument = gql`
  query GetQueryAdvisorServerOverview(
    $serverId: ID!
    $checkGroupsAndNames: [String!]
  ) {
    getDatabases(serverId: $serverId, hidden: false) {
      id
      datname
      issueCount(checkGroupsAndNames: $checkGroupsAndNames)
    }
  }
`;

/**
 * __useGetQueryAdvisorServerOverviewQuery__
 *
 * To run a query within a React component, call `useGetQueryAdvisorServerOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQueryAdvisorServerOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQueryAdvisorServerOverviewQuery({
 *   variables: {
 *      serverId: // value for 'serverId'
 *      checkGroupsAndNames: // value for 'checkGroupsAndNames'
 *   },
 * });
 */
export function useGetQueryAdvisorServerOverviewQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetQueryAdvisorServerOverviewQuery,
    GetQueryAdvisorServerOverviewQueryVariables
  > &
    (
      | {
          variables: GetQueryAdvisorServerOverviewQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetQueryAdvisorServerOverviewQuery,
    GetQueryAdvisorServerOverviewQueryVariables
  >(GetQueryAdvisorServerOverviewDocument, options);
}
export function useGetQueryAdvisorServerOverviewLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetQueryAdvisorServerOverviewQuery,
    GetQueryAdvisorServerOverviewQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetQueryAdvisorServerOverviewQuery,
    GetQueryAdvisorServerOverviewQueryVariables
  >(GetQueryAdvisorServerOverviewDocument, options);
}
// @ts-ignore
export function useGetQueryAdvisorServerOverviewSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetQueryAdvisorServerOverviewQuery,
    GetQueryAdvisorServerOverviewQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetQueryAdvisorServerOverviewQuery,
  GetQueryAdvisorServerOverviewQueryVariables
>;
export function useGetQueryAdvisorServerOverviewSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetQueryAdvisorServerOverviewQuery,
        GetQueryAdvisorServerOverviewQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetQueryAdvisorServerOverviewQuery | undefined,
  GetQueryAdvisorServerOverviewQueryVariables
>;
export function useGetQueryAdvisorServerOverviewSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetQueryAdvisorServerOverviewQuery,
        GetQueryAdvisorServerOverviewQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetQueryAdvisorServerOverviewQuery,
    GetQueryAdvisorServerOverviewQueryVariables
  >(GetQueryAdvisorServerOverviewDocument, options);
}
export type GetQueryAdvisorServerOverviewQueryHookResult = ReturnType<
  typeof useGetQueryAdvisorServerOverviewQuery
>;
export type GetQueryAdvisorServerOverviewLazyQueryHookResult = ReturnType<
  typeof useGetQueryAdvisorServerOverviewLazyQuery
>;
export type GetQueryAdvisorServerOverviewSuspenseQueryHookResult = ReturnType<
  typeof useGetQueryAdvisorServerOverviewSuspenseQuery
>;
export type GetQueryAdvisorServerOverviewQueryResult = Apollo.QueryResult<
  GetQueryAdvisorServerOverviewQuery,
  GetQueryAdvisorServerOverviewQueryVariables
>;
